import { render, staticRenderFns } from "./upload-ppt.vue?vue&type=template&id=696537a6&scoped=true&"
import script from "./upload-ppt.vue?vue&type=script&lang=js&"
export * from "./upload-ppt.vue?vue&type=script&lang=js&"
import style0 from "./upload-ppt.vue?vue&type=style&index=0&id=696537a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696537a6",
  null
  
)

export default component.exports